export const EVENT_TYPES = [
  { id: 'Music', label: 'Music' },
  { id: 'Theatre & Art', label: 'Theatre & Art' },
  { id: 'Comedy', label: 'Comedy' },
  { id: 'Performance', label: 'Performance' },
];

export const SIDEBAR_MENU_LIST = [
  { label: 'Event Details',
    value: 'details',
  },
  // { label: 'Ticket Details', 
  //   value: 'ticket-details', 
  // },
  { label: 'Venue Details', 
    value: 'venue-details', 
  },
];

export const ADD_VENUE_OPTION = [{
  id: 'add-venue',
  label: 'Add Venue',
}];